export default __webpack_public_path__ + "static/media/dos.61fee3ca.mp3";